import __request__ from "routing/request";
export function getInstallationStatus(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/processing/restart", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function restartProcessing(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/processing/restart", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
